<template>
  <div class="bg-purple-light">
    <div class="content">
      <Navbar is-logged-in />

      <div class="d-flex justify-content-center">
        <div class="white-box my-5 mx-3">
          <div class="m-3 p-4">
            <p class="text-welcome mb-1">
              {{ $t("login.welcome") }}
            </p>
            <p class="text-app mb-1">
              Fit Daily Monitoring
            </p>
            <p class="text-one mb-0 pb-4">
              {{ $t("success-login.text-one") }}
            </p>
            <div class="box-image-temp">
              <img
                src="@/assets/image/checklist-pana.9ebf6fb0.png"
                alt="checklist-pana"
              >
            </div>
            <p class="text-two">
              {{ $t("success-login.text-two") }}
            </p>
            <div class="row text-center mt-4">
              <div
                class="col-6 px-2"
                @click="defaultSkip"
              >
                <div
                  class="py-2 button-skip"
                >
                  {{ $t("success-login.button-skip") }}
                </div>
              </div>
              <div class="col-6 px-2">
                <router-link
                  tag="div"
                  class="py-2 button-next"
                  to="instruction"
                >
                  {{ $t("success-login.button-next") }}
                </router-link>
              </div>
            </div>
            <p class="text-three text-center">
              {{ $t("success-login.text-three") }}
              "<b>{{ $t("success-login.text-four") }}</b>"
              {{ $t("success-login.text-five") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'

export default {
  name: 'SuccessLogin',

  components: {
    Navbar
  },

  methods: {
    async defaultSkip () {
      const defaultRouting = JSON.parse(localStorage.getItem('defaultRoute'))

      this.$router.push({
        name: defaultRouting.category
      })
    }
  }
}
</script>

<style scoped>
.content {
  background-image: url('~@/assets/image/bg-2.png');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 100vh;
}
.white-box {
  background: white;
  max-width: 500px;
  border-radius: 18px;
}
.white-box .text-welcome {
  color: #aaaaaa;
  font-weight: bold;
  font-size: 12px;
}
.white-box .text-app {
  color: #121212;
  font-size: 18px;
  font-weight: bold;
}
.white-box .text-one {
  color: #18b2bd;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 2px solid #dedede;
}
.box-image-temp {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 40px;
  justify-content: center;
  justify-items: center;
}
.box-image-temp img {
  width: 300px;
  height: 300px;
  justify-content: center;
}
.white-box .text-two {
  color: #121212;
  line-height: 24px;
  font-size: 13px;
  font-weight: 800;
  text-align: center;
}
.button-skip {
  background-color: #FFFFFF;
  border: 1px solid #18B2BD;
  border-radius: 4px;
  border: 2px solid #18B2BD;
  color: #18B2BD;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.button-next {
  background-color:#18B2BD;
  border: 1px solid #18B2BD;
  border-radius: 4px;
  border: 2px solid #18B2BD;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.white-box .text-three {
  color: #18b2bd;
  font-size: 13px;
  font-weight: 600;
  margin-top: 35px;
}
</style>
